module.exports = __webpack_public_path__ + "media/images/icons/academic-development_03-4468b6269db368de6e131e3ac41b27c8.svg";